import { Nav } from "./components/nav";

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'
import { ColorTransition } from './components/colorTransition';
import { Module03Podcast } from "./modules/module-03-podcast";
import { Module04Steps } from "./modules/module-04-steps";
import { Module05Contact } from "./modules/module-05-contact";
import { Module06Testimonial } from "./modules/module-06-testimonial";
import { Module07SliderCards } from "./modules/module-07-slider-cards";
import { Module12ContentData } from "./modules/module-12-content-data";
import { Module13ContentAccordion } from "./modules/module-13-content-accordion";

class App {
	constructor() {
		const nav = new Nav();

		// if(document.querySelector('.dropdown')) {
		//   const dropdown = new DropDown;
		// }
		// if(document.querySelector('.popup')) {
		//   const popup = new PopUp;
		// }

		const colorTransition = new ColorTransition();

		if (document.querySelector(".module-03-podcast")) {
			const module03Podcast = new Module03Podcast();
		}
		
		if (document.querySelector(".module-04-steps")) {
			const module04Steps = new Module04Steps();
		}

		if (document.querySelector(".module-05-contact")) {
			const module05Contact = new Module05Contact();
		}

		if (document.querySelector(".module-06-testimonial")) {
			const module06Testimonial = new Module06Testimonial();
		}

		if (document.querySelector(".module-07-slider-cards")) {
			const module07SliderCards = new Module07SliderCards();
		}

		if (document.querySelector(".module-12-content-data")) {
			const module12ContentData = new Module12ContentData();
		}

		if (document.querySelector(".module-13-content-accordion")) {
			const module13ContentAccordion = new Module13ContentAccordion();
		}

	}
}

window.onload = function() {
	let app = new App();
};
